import styled from "styled-components";

export const HeaderContainer = styled.header`
  background-image: linear-gradient(
    to bottom,
    #121214 50%,
    rgba(50, 50, 56, 0.5)
  );
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
`;

export const List = styled.ul`
  cursor: pointer;

  @media (min-width: 320px) {
    align-items: start;
  }
  @media (min-width: 1400px) {
    align-items: center;
  }
`;
